module.exports = __webpack_public_path__ + "img/plot_icon02.3e355d24.png";